import React from 'react'
import { adjustScheduleStartTime } from '../../actions/restaurantPoolSchedule'
import Wrapper from '../../components/wrapper'
import PropTypes from 'prop-types'
import './styles.css'
import moment from '../../helpers/moment'
import MomentDatePicker from '../../components/momentDatePicker'
import Loader from '../../components/loader'

export class RestaurantPoolScheduleErrors extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      invalidScheduleRows : props.invalidScheduleRows || []
    }
  }

  updateErrorSchedule(objToUpdate, newFields){
    this.setState(prevState => ({
      invalidScheduleRows: prevState.invalidScheduleRows.map(schedule => {
        if (schedule !== objToUpdate) return schedule;
        return { ...schedule, ...newFields };
      })
    }));
  }

  render() {
    const errorCount = this.state.invalidScheduleRows.length
    const isActionDisabled = this.props.isLoading || this.props.isActionDisabled
    const disabledClassName = this.props.isActionDisabled ? 'legacy-disabled-action' : ''
    return <Wrapper title={'Pool Schedule Errors'} >
      <div className="restaurant-pool-schedule pool-schedule-errors">

        {!errorCount
          ? <div className="alert alert-success" role="alert">
            There are no more errors in the import
          </div>
          : <div>
            <h5><span className="fa fa-exclamation-triangle mr-3 text-danger" />{`${errorCount} error${errorCount>1?'s':''} not imported`}</h5>

            <table className="table">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Restaurant name</th>
                  <th scope="col">New pool</th>
                  <th scope="col">Start date</th>
                  <th scope="col" />
                </tr>
              </thead>

              <tbody>
                {this.state.invalidScheduleRows.map(schedule=>{

                  const startDateMoment = moment.parseZone(schedule.startDateUtc, moment.ISO_8601, true)

                  return <tr key={schedule.id}>
                    <td className="align-middle">{schedule.isRestaurantValid
                      ? schedule.restaurant.id
                      : <input className="form-control is-invalid restaurant-id-input"
                        type="text"
                        disabled={isActionDisabled}
                        value={schedule.restaurant.id}
                        onChange={e => this.updateErrorSchedule(schedule, {restaurant:{id:e.target.value}})}/>}
                    </td>
                    <td className="align-middle">{schedule.restaurant.name || "?"}</td>

                    <td className="align-middle">{schedule.isPoolValid
                      ? schedule.pool.name
                      : <input className="form-control is-invalid pool-name-input"
                        type="text" disabled={isActionDisabled}
                        value={schedule.pool.name}
                        onChange={e => this.updateErrorSchedule(schedule, {pool:{name:e.target.value}})}/>}
                    </td>

                    <td className="align-middle">{schedule.isStartDateUtcValid && startDateMoment.isValid()
                      ? <abbr title={startDateMoment.format("dddd, MMMM Do YYYY, HH:mm:ss ([GMT]Z)")}>{startDateMoment.format("DD-MMM-YYYY")}</abbr>
                      : <MomentDatePicker
                        className="startDate-input"
                        value={startDateMoment}
                        disabled={isActionDisabled}
                        isValid={false}
                        onChange={date =>this.updateErrorSchedule(schedule, {startDateUtc:date.isValid() ? adjustScheduleStartTime(date).format() : date.creationData().input})}
                        timeZone={schedule.pool.timeZone || this.props.defaultTimeZone}
                        minDate={moment.tz(schedule.pool.timeZone || this.props.defaultTimeZone)}
                        maxDate={moment.tz(schedule.pool.timeZone || this.props.defaultTimeZone).add(1, 'year')} />}
                    </td>

                    <td className="align-middle ">
                      <ul className="schedule-errors">
                        {schedule.isRestaurantValid ? null : <li className="text-danger">Restaurant ID is not recognised</li>}
                        {schedule.isPoolValid ? null : <li className="text-danger">Pool name is not recognised</li>}
                        {schedule.isStartDateUtcValid ? null : <li className="text-danger">Invalid date</li>}
                      </ul>
                    </td>
                  </tr>
                })}
              </tbody>
            </table>
          </div>}

        <div className="edit-button-bar text-right">
          {this.props.isLoading ? <Loader/> : null}
          <button
            id="btnBack"
            className="btn btn-sm btn-secondary mr-1"
            disabled={this.props.isLoading}
            onClick={() => this.props.onBack()}>
              Back
          </button>
          <span title={this.props.disabledTitle}>
            <button
              id="btnSkipErrors"
              className={`btn btn-sm btn-secondary mr-1 ${disabledClassName}`.trim()}
              disabled={isActionDisabled}
              onClick={() => this.props.onIgnoreErrors()}>
                Skip errors
            </button>
          </span>
          <span title={this.props.disabledTitle}>
            <button
              id="btnRetryErrors"
              className={`btn btn-sm btn-primary ${disabledClassName}`.trim()}
              disabled={isActionDisabled}
              onClick={() => this.props.onUpdateScheduleRows(this.state.invalidScheduleRows)}>
                Retry errors
            </button>
          </span>
        </div>

      </div>
    </Wrapper>
  }
}

RestaurantPoolScheduleErrors.propTypes = {
  isLoading: PropTypes.bool,
  isActionDisabled: PropTypes.bool,
  disabledTitle: PropTypes.string,
  invalidScheduleRows: PropTypes.array.isRequired,
  defaultTimeZone: PropTypes.string,

  onUpdateScheduleRows:  PropTypes.func.isRequired,
  onIgnoreErrors:  PropTypes.func.isRequired,
  onBack:  PropTypes.func.isRequired,
}

RestaurantPoolScheduleErrors.defaultProps = {
  isActionDisabled: false,
  disabledTitle: ''
}

export default RestaurantPoolScheduleErrors



// WEBPACK FOOTER //
// ./src/containers/restaurant-pool-schedule/RestaurantPoolScheduleErrors.js